const messageTypes = {
  success: 'success',
  error: 'error',
  info: 'info',
};

export { messageTypes };
